import React, { forwardRef } from 'react';
import classNames from 'classnames';

import { Avatar, AvatarRadii, AvatarSizes } from 'components/Avatar';

interface Props {
  id: string;
  name: string;
  image: string;
  onSelect: (id: string) => void;
  isSelected: boolean;
  isDisabled: boolean;
}

const MemberOnlyRow = forwardRef<HTMLLIElement, Props>(
  ({ name, image, id, onSelect, isSelected, isDisabled }, ref) => {
    const handleSelect = () => {
      if (isSelected || !isDisabled) {
        onSelect(id);
      }
    };

    return (
      <li
        ref={ref}
        className={classNames(
          'rounded-lg flex p-2 items-center gap-3 cursor-pointer',
          isSelected && 'bg-primary-50',
          !isSelected && isDisabled && 'opacity-50 cursor-not-allowed'
        )}
        onClick={handleSelect}
      >
        <Avatar radius={AvatarRadii.Lg} src={image} size={AvatarSizes.Lg} />
        <div className="flex-1 font-bold  text-base">{name}</div>
        <input
          className="mt-1 mr-2"
          type="checkbox"
          checked={isSelected}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
        />
      </li>
    );
  }
);

export default MemberOnlyRow;
